export default __webpack_public_path__ + "static/media/noData.bcd96bdd.svg";